import { Link } from "react-router-dom";
import logo from "./assets/logo.svg";
import { useAccount } from "context/AccountContext";

function Logo() {
  const { user } = useAccount();
  return (
    <Link to={ user ? '/startpagina' : '/' }>
      <img src={ logo } alt="Trefpunt" width={ 300 } height={ 69 }/>
    </Link>
  )
}

export default Logo;
